import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { of, groupBy, mergeMap, reduce, map, toArray, first } from 'rxjs';
import { TankCoverageArea } from 'src/app/models/farmers-application.model';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { ConfirmationService, MenuItem } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { DashboardService } from 'src/app/services/dashboard.service';
import { OnFarmMiService } from 'src/app/services/on-farm-mi.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-farmers-application',
  templateUrl: './farmers-application.component.html',
  styleUrls: ['./farmers-application.component.scss'],
  providers: [ConfirmationService],
})
export class FarmersApplicationComponent implements OnInit {
  farmersApplicatonForm: FormGroup;
  selectedPrimarySolarVendor: any;
  selectedSecondarySolarVendor: any;
  selectedSecondarySolarVendorId: any;
  // miSolarApplicationForm: FormGroup;
  solarApplicatonForm: FormGroup;
  miApplicatonForm: FormGroup;
  onFarmPondApplicatonForm: FormGroup;
  filteredVillage: any[];
  selectedVillage: any;
  villageList = [];
  // waterSourceTypeList: { waterSource: any; component: any[] }[] = [];
  waterSourceTypeList: any;
  applicationTypeList: any = [];
  componentList: any = [];
  miList: any = [];
  miVendorList: any = [];
  filteredmiVendorList: any = [];
  miDetailsList = [];
  solarVendorList = [];
  primarySolarVendorList = [];
  secondarySolarVendorList = [];
  componentSelected: any;
  addBankDialog: boolean;
  addFarmerGroupDialog: boolean;
  bankAccount: any;
  selectedVendor: any;
  bankAccountList: any = [];
  selectedBankAccounts: any = [];
  applicationSelected: any;
  pumpCapacityList: { name: string; code: string }[];
  solarMasterData: any = [];
  selectedWatersourceType: any;
  schemeMasterList: { type: any; data: any[] }[];
  landIDList: any;
  selectedLandIdList: any;
  tankListMaster: any;
  coverageAreaSelected: TankCoverageArea = new TankCoverageArea();
  farmerDetailsList: any;
  selectedFarmerDetail: string[] = [];
  filteredFarmerDetail: any[];
  bankAccountSelected: any;
  selectedFarmerLandDetails: any[];
  selectedFarmersLandList: any[];
  selectedFarmersLandIdList: any[] = [];
  selectedGroupFarmersLandList: any[];

  watercourseApplicatonForm: FormGroup;
  canalOutletList: { canal: any; data: any[] }[];
  outletTypeList: any[];
  workTypeMasterList: any;
  villageCodeOutlets = [];
  villageCodeFarmer = [];
  selectedVillageCode: any;
  allSchemeMaster: any[] = [];
  selectedVillageName: any;
  selectedPondLand: any;
  selectedSolardLandId: any;
  applicationId: string;
  selectedSchemeId: any;
  consentUploadPath: any;
  miSelectedVendor: any;
  farmerPreviousSubsidies: any = [];
  farmerId: any;
  totalNumberOfFarmersInGroup: number;
  componentMaster: any;
  currentTotalArea: any;
  previousTotalArea: any;
  totalSubsidyArea: any
  public selectedMI: any;
  public vendorList: any = [];
  public selectedProgramId: any;
  public isDisabled=false
  public isSubmittedWaterCourseFrom: boolean = false;
  public isSubmittedPondApplicatonForm: boolean = false;
  public isSubmittedSolarApplicatonFrom: boolean = false;
  allLandsOfApplication: any;
  public isVillhasCanal: boolean = true;
  public showWaterCourseForm: boolean = true;
  public showComponent: boolean = true;
  public isTargetReached: boolean = false;
  public isVillageSelected: boolean = false;
 public targetStatusBody={}
  ipAddress: any = '000.000.000';

  constructor(
    private route: ActivatedRoute,
    public router: Router,
    private confirmationService: ConfirmationService,
    private _fb: FormBuilder,
    private farmerAppSer: FarmersApplicationService,
    private messageService: MessageService,
    private farmersBankService: BankDetailService,
    private _personalDetalSer: FarmersDetailsService,
    private _dashboardService: DashboardService,
    private ofService: OnFarmMiService,
    private activityRecordService : ActivityRecordService,
    private loader: AppLoaderService,
    private ipService: IpAddressService,
  ) { }

  ngOnInit() {
    this.getIP();
    let farmerData = JSON.parse(window.sessionStorage.getItem('farmerDetails'));
    this.farmerId = farmerData?.Farmer_ID;

    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    this.activityRecordService.activityRecord(mobile, 'Add/Edit Application', this.farmerId, new Date(), 'Success');

    this.getPastSubsidiesByFarmerId();
    let appId = this.route.snapshot.paramMap.get('appId');
    this.applicationId = appId;
    this.getSchemeMaster();
    this.getSolarMaster();
    this.getComponentMaster();

    // this.getAllMiVendors();
    this.getWorkTypeMasterData();
    this.getAllTank();

    // this.getLandIds();
    this.getBankListOfFarmer();
    this.getVillageData(this.farmerId);
    this.farmersApplicatonForm = this._fb.group({
      waterSourceType: [''],
      applicationType: [''],
      component: [''],
      gender: [''],
    });
    this.solarApplicatonForm = this._fb.group({
      controlType: ['', Validators.required],
      pump: ['', Validators.required],
      pumpType: ['', Validators.required],
      pumpCapacity: ['', Validators.required],
      primaryVendor: ['', Validators.required],
      secondaryVendor: [''],
      farmerShare: [''],
      solarId: ['', Validators.required],
      landId: ['', Validators.required],
    });
    this.miApplicatonForm = this._fb.group({
      mi: [''],
      vendor: [''],
      landId: [''],
    });

    this.watercourseApplicatonForm = this._fb.group({
      canal: ['', Validators.required],
      outlet: ['', Validators.required],
      workType: ['', Validators.required],
      checkBox: ['', Validators.required],
    });

    this.onFarmPondApplicatonForm = this._fb.group({
      landId: ['', Validators.required],
      sizeCoverageArea: ['', Validators.required],
      topSize: [''],
      bottomSize: [''],
      depth: [''],
      waterCapacity: [''],
      tenativeCost: [''],
      tankId: [''],
    });

    this.waterSourceTypeList = [];

    this.pumpCapacityList = [
      { name: '3 HP', code: '3 HP' },
      { name: '5 HP', code: '5 HP' },
      { name: '7.5 HP', code: '7.5 HP' },
      { name: '10 HP', code: '10 HP' },
    ];

    if (appId) {
      setTimeout(() => {
        this.populateForm(appId);
      }, 2000);
    }
    else {
      this.getLandIds();
    }
  }

  resetFromSubmissionState() {
    this.isSubmittedWaterCourseFrom = false;
    this.isSubmittedPondApplicatonForm = false;
    this.isSubmittedSolarApplicatonFrom = false;
  }

  get watercourseFormControls() {
    return this.watercourseApplicatonForm.controls;
  }

  get farmPondApplicatonFormControls() {
    return this.onFarmPondApplicatonForm.controls;
  }

  get solarApplicatonFormControls() {
    return this.solarApplicatonForm.controls;
  }

  populateForm(appId) {
    this.loader.start();
    this._dashboardService
      .getApplicationByAppId(appId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.APP_ID) {
            //Populating Farmer Application Form
            if (data.FarmerLand) {
              this.landIDList = [];
              this.allLandsOfApplication = data.FarmerLand;
              this.landIDList = this.transformLandIDData(data.FarmerLand);
              console.log(this.landIDList)
            }
            if (data.Scheme_ID) {
              this.selectedSchemeId = data.Scheme_ID;
              let populatedScheme = this.allSchemeMaster.filter(
                (x) => x.Scheme_ID === data.Scheme_ID
              );

              // console.log('populatedScheme1', populatedScheme);

              if(populatedScheme.length == 0){

                this.loader.start();
                this.farmerAppSer.getSchemeMaster(data.Scheme_ID)
                  .pipe(first())
                  .subscribe({
                    next: (data) => {
                      populatedScheme = data;
                      this.loader.close();
                    },
                    error: (err) => {
                      this.loader.close();
                      this.messageService.add({
                        severity: 'error',
                        summary: 'Error Message',
                        detail: 'For the current Scheme ID data is not found.',
                      });
                      return;
                    },
                    complete: () => {
                      this.onApplicationTypeSelected({
                        value: populatedScheme[0].Applicant_type,
                      });
                      this.onVillageSelect({
                        VillageCode: data.VillageData[0].VillageCode,
                        VillageName: data.VillageData[0].VillageName,
                      });
                      this.onWaterSourceTypeSelected({
                        value:
                          this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
                            .waterSource,
                      }, 'exists', populatedScheme);
                      const populatedComponent = this.componentList.filter(
                        (x) => x.Scheme_ID === data.Scheme_ID
                      );
                      this.onComponentSelected({ value: populatedComponent[0] });
                  
                      this.populateApllicationDataOnSchemeID(data, populatedScheme);
                    }
                  });
              }else{
                this.onApplicationTypeSelected({
                  value: populatedScheme[0].Applicant_type,
                });
                this.onVillageSelect({
                  VillageCode: data.VillageData[0].VillageCode,
                  VillageName: data.VillageData[0].VillageName,
                });
                this.onWaterSourceTypeSelected({
                  value:
                    this.waterSourceTypeList[populatedScheme[0].Water_Source - 1]
                      .waterSource,
                });
                const populatedComponent = this.componentList.filter(
                  (x) => x.Scheme_ID === data.Scheme_ID
                );
                this.onComponentSelected({ value: populatedComponent[0] });
            
                this.populateApllicationDataOnSchemeID(data, populatedScheme);
              }


              
              // console.log("selectedWatersourceType", this.selectedWatersourceType);
              // console.log("componentSelected", this.componentSelected);
            }
            

          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Requested Application Not Found.',
            });
            return;
          }
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Requested Application Not Found.',
          });
          return;
        },
      });
  }

  populateApllicationDataOnSchemeID(data, populatedScheme){

    if (data.ConsentPath) {
      this.consentUploadPath = data.ConsentPath;
    }
    //populating Farmer Details
    if (data.Group_Datas) {
      data.Group_Datas.forEach((x) => {
        x.landDetails = data.FarmerLand.filter((land) => {
          return land.farmerId === x.Farmer_ID;
        });
        this.selectedFarmerLandDetails.push(x);
      });
      data.GroupTableData.forEach((x) => {
        this.selectedFarmersLandIdList.push({ Land_ID: x.LandID });
      });
      this.saveFarmerToGroup();
      // this.selectedFarmersLandList = data.GroupTableData;
    }

    //Populating MI Data
    this.miDetailsList = [];
    if (data.New_MI_Datas) {
      data.New_MI_Datas.forEach((x) => {
        let filteredList = this.miVendorList.filter((vendor) => {
          return vendor.Name == x.miVendorName;
        });
        this.miSelectedVendor = filteredList[0];
        let component = 0;
        this.componentMaster.forEach((val) => {
          if( x.programName == val.Program_Name){
            component =  val.Program_Id;
          }
        })

        let body = {
          mi: component,
          vendor: x.miVendorName,
          landId: x.LandID,
          vendorCode: x.VendorCode,
          vendorObject: filteredList[0],
          landData: x.landData,
          totalArea: x.totalArea,
        };
        this.miDetailsList.push(body);
        console.log(this.miDetailsList)
      });
    }

    //populating Bank
    this.onBankAccountSelected({
      value: data.FarmerBank?.accoNumber?.toString(),
    });

    //Populating Pond Farm
    if (data.OnFarm_Pond_Datas) {
      // let selectedLand = this.landIDList.filter((x) => {
      //   return x.Land_ID === data.OnFarm_Pond_Datas[0].LandID;
      // });
      let selectedLand = data.OnFarm_Pond_Datas;
      this.onPondLandIdSelected({ value: selectedLand[0] });
      this.onFarmPondApplicatonForm.controls.landId.setValue(
        selectedLand[0].Land_ID
      );

      let filteredTankMaster = this.tankListMaster.filter((x) => {
        return (
          x.Coverage_Area == data.OnFarm_Pond_Datas[0].CoverageArea
        );
      });
      this.onCoverageAreaSelected({ value: filteredTankMaster[0] });
    }

    //populating Solar Form
    if (data.Solar_Pump_Datas) {
      // let selectedLand = this.landIDList.filter((x) => {
      //   return x.Land_ID === data.Solar_Pump_Datas[0].LandID;
      // });
      let selectedLand = data.Solar_Pump_Datas;
      this.solarApplicatonForm.controls.landId.setValue(
        selectedLand[0].Land_ID
      );
      this.solarApplicatonForm.controls.controlType.setValue(
        data.Solar_Pump_Datas[0].controlerType
      );
      this.solarApplicatonForm.controls.pump.setValue(
        data.Solar_Pump_Datas[0].type
      );
      this.solarApplicatonForm.controls.pumpType.setValue(
        data.Solar_Pump_Datas[0].pumpCategory
      );
      this.solarApplicatonForm.controls.pumpCapacity.setValue(
        data.Solar_Pump_Datas[0].pumpCapacity
      );
      this.validateAndGetSolarVendors();
      this.selectedPrimarySolarVendor =
        data.Solar_Pump_Datas[0].primaryVendor;
      this.selectedSecondarySolarVendor =
        data.Solar_Pump_Datas[0].secondaryVendor;

      this.solarApplicatonForm.controls.farmerShare.setValue(
        data.Solar_Pump_Datas[0].farmerShare
      );
    }

    if (data?.Water_Course_Datas) {
      this.watercourseApplicatonForm.controls.canal.setValue(data?.Water_Course_Datas[0]?.Canal_Outlet_Name);
      this.watercourseApplicatonForm.controls.outlet.setValue(data?.Water_Course_Datas[0]?.Outlet_Code);
      this.watercourseApplicatonForm.controls.workType.setValue(data?.Water_Course_Datas[0]?.Work_type);
      console.log(this.watercourseApplicatonForm.controls)
    }
  }

  //get all list
  getBankListOfFarmer() {
    let farmerData: any = sessionStorage.getItem('farmerDetails');
    let appNo = JSON.parse(farmerData).Farmer_ID;

    this.loader.start();
    this.farmersBankService.getBankDetails(appNo).subscribe((res) => {
      this.loader.close();
      this.bankAccountList = res.map((r) => {
        return { ...r, displayName: r.Account_NO + ' - ' + r.Bank_NAME };
      });
    });
  }

  getAllOutletData(villageCode: any) {
    this.loader.start();
    this.farmerAppSer.GetAllOutletDetails(villageCode).subscribe((res) => {
      of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
    });
  }

  listAllOutletData() {
    this.loader.start();
    this.farmerAppSer.LetAllOutletDetails().subscribe((res) => {
      of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
    });
  }

  getWorkTypeMasterData() {
    this.loader.start();
    this.farmerAppSer.GetWorktypeMaster().subscribe((res) => {
      this.workTypeMasterList = res;
      this.loader.close();
    });
  }
  getComponentMaster() {
    this.loader.start();
    this.farmerAppSer.getComponentMaster().subscribe((res) => {
      console.log("componentMaster", res)
      this.componentMaster = res;
      this.miList = res;
      this.loader.close();
    });
  }
  getLandIds() {
    // let mobNo = sessionStorage.getItem('farmerPh');
    let farmerData: any = sessionStorage.getItem('farmerDetails');
    let appNo = JSON.parse(farmerData).Farmer_ID;

    // this.farmerAppSer.getFarmersLandId(appNo).subscribe((res) => {
    this.loader.start();
    this.farmerAppSer.getNotUsedLandsByFarmerID(appNo).subscribe((res) => {
      this.loader.close();
      this.landIDList = this.selectedLandIdList = this.transformLandIDData(
        res.Table
      );

      let villageCodeList = this.landIDList?.map((res) => res.Village_Code);
      this.getAllOutletData(villageCodeList);
    });
  }

  transformLandIDData(inputData) {
    return inputData?.map((r) => {
      return {
        ...r,
        displayName:
          'Village Name:' +
          (r.VillageName ? r.VillageName : this.selectedVillageName )+
          ' - Killa No:' +
          ((r.Killa_No ? r.Killa_No : r.killaNo)
            ? r.Killa_No
              ? r.Killa_No
              : r.killaNo
            : r.KillaNo) +
          ' - Morabba No:' +
          ((r.Morabba_No ? r.Morabba_No : r.morabbaNo)
            ? r.Morabba_No
              ? r.Morabba_No
              : r.morabbaNo
            : r.MorabbaNo),
      };
    });
  }

  getSchemeMaster() {
    this.loader.start();
    this.farmerAppSer.getSchemeMaster().subscribe((res) => {
      this.allSchemeMaster = res;
      of(...res)
        .pipe(
          groupBy((p: any) => p.Applicant_type),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ type: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          this.schemeMasterList = p;
          this.loader.close();
        });
    });
  }

  getPastSubsidiesByFarmerId() {
    if (this.farmerId) {
      this.loader.start();
      this.ofService
        .GetFarmerPastSubsidyByFarmerId(this.farmerId)
        .pipe(first())
        .subscribe({
          next: (data) => {
            this.farmerPreviousSubsidies = data;
            this.loader.close();
          },
          error: () => {
            this.loader.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! Farmer Previous Subsidies not loaded.',
            });
          },
        });
    }
  }

  getVillageData(farmerId) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';
    this.loader.start();
    this._personalDetalSer.getVillageBasedOnFarmerId(farmerId)
    .pipe(first())
    .subscribe({
      next: (res) => {
        this.activityRecordService.activityRecord(
          mobile,
          'Get Village Based On Farmer Id',
          this.farmerId,
          new Date(),
          JSON.stringify(res)
        );

        this.villageList = res;
        this.loader.close();
        this.filteredVillage = [...this.villageList];
      },
      error: (err) => {
        this.loader.close();
        this.activityRecordService.activityRecord(
          mobile,
          'Get Village Based On Farmer Id',
          this.farmerId,
          new Date(),
          err
        );

        this.messageService.add({
          severity: 'error',
          summary: 'Village Error Message. Please add the land details first and try again',
          detail: err,
        });
      },
    });
    // this._personalDetalSer.getVillageBasedOnFarmerId(farmerId).subscribe((res) => {
    //   this.villageList = res;
    //   this.loader.close();
    //   this.filteredVillage = [...this.villageList];

      // if (!window.sessionStorage.getItem('villageMaster')) {
      //   window.sessionStorage.setItem('villageMaster', JSON.stringify(res));
      // }
    // });
    // console.log(this.villageList);
  }
  filterVillage(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.villageList.length; i++) {
      const village = this.villageList[i];
      if (village.VillageName.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(village);
      }
    }
    this.filteredVillage = filtered;
  }
  filterMIVendor(event: any) {
    const filtered: any[] = [];
    const query = event.query;
    for (let i = 0; i < this.miVendorList.length; i++) {
      const vendor = this.miVendorList[i];
      if (vendor.Name.toLowerCase().indexOf(query.toLowerCase()) == 0) {
        filtered.push(vendor);
      }
    }
    this.filteredmiVendorList = filtered;
  }
  GetAllFarmerDetails(villageCode: any) {
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    if (this.applicationId) {
      this.landIDList = this.transformLandIDData(this.allLandsOfApplication);
    } else {
      if (this.applicationSelected === 'Individual') {
        this.getFarmerLandByFarmerIds();
      } else {
        this.loader.start();
        this.farmerAppSer.GetFarmerAndLandByVillageCode(villageCode).subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.farmerDetailsList = data;
              this.getFarmerLandByFarmerIds();
            }
          },
          error: (err) => {
            this.loader.close();
            console.log(err);
          },
        });
      }
    }
  }
  onVillageSelect(val: any) {
    this.isVillageSelected = true;
    this.resetApplication();
    this.villageCodeFarmer = [];
    this.selectedVillageName = val.VillageName;
    this.selectedVillageCode = val.VillageCode;
    this.selectedVillage = val;
    this.selectedFarmerLandDetails = [];
    this.farmerDetailsList = [];
    this.selectedWatersourceType = null;
    this.componentSelected = null;
    this.villageCodeFarmer.push(val.VillageCode);
    this.GetAllFarmerDetails(this.villageCodeFarmer);
    // this.getAllOutletDataN(this.villageCodeFarmer);
    this.getAllOutletDataN(this.villageCodeFarmer);
  }

  // getAllMiVendors() {
  //   this.farmerAppSer.getAllMiVendors().subscribe({
  //     next: (data) => {
  //       if (data) {
  //         this.miVendorList = data;
  //         this.filteredmiVendorList = [...this.miVendorList];
  //       }
  //     },
  //     error: (err) => {
  //       console.log(err);
  //     },
  //   });
  // }
  getAllSolarVendors() {
    this.loader.start();
    this.farmerAppSer.getAllSolarVendors().subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.solarVendorList = data;
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  getPrimarySolarVendors() {
    this.primarySolarVendorList = [];

    let solarMasteredFilteredData = this.getFarmerShare();
    if (solarMasteredFilteredData) {
      this.solarApplicatonForm.patchValue({
        farmerShare: solarMasteredFilteredData.Farmers_Share,
      });
      this.solarApplicatonForm.patchValue({
        solarId: solarMasteredFilteredData.Solar_ID,
      });

      this.loader.start();
      this.farmerAppSer
        .getPrimarySolarVendors(solarMasteredFilteredData.Solar_ID)
        .subscribe({
          next: (data) => {
            this.loader.close();
            if (data) {
              this.primarySolarVendorList = data;
              if (this.applicationId) {
                this.onPrimarySolarVendorChange({
                  value: this.selectedPrimarySolarVendor,
                });
              }

            }
          },
          error: (err) => {
            this.loader.close();
            console.log(err);
          },
        });
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! Solar ID Not Found For selected Combination',
      });
    }
  }

  onPrimarySolarVendorChange(event) {
    this.selectedPrimarySolarVendor = event.value;
    let solarMasteredFilteredData = this.getFarmerShare();
    console.log(this.primarySolarVendorList)
    let selectedPrimaryVendor = this.primarySolarVendorList.filter(vendor => {
      return vendor.Primary_Vendor === event.value
    })
    if (selectedPrimaryVendor.length) {
      this.getSecondarySolarVendors(selectedPrimaryVendor[0].pid);
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'PID value is unknown for Selcted Primary Vendor, Hence Secondary Vendor is not known',
      });
      return;
    }

  }

  onSecondarySolarVendorChange(event) {
    this.selectedSecondarySolarVendor = event.value;
    let selectedSolarVendor = this.secondarySolarVendorList.filter((x) => {
      return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
    });
    this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
  }

  getSecondarySolarVendors(solarId: any) {
    this.loader.start();
    this.farmerAppSer.getSecondarySolarVendors(solarId).subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.secondarySolarVendorList = data;
          if (this.selectedSecondarySolarVendor) {
            let selectedSolarVendor = this.secondarySolarVendorList.filter(
              (x) => {
                return x.Secondary_Vendor === this.selectedSecondarySolarVendor;
              }
            );
            this.selectedSecondarySolarVendorId = selectedSolarVendor[0].sid;
          }
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  getAllTank() {
    this.loader.start();
    this.farmerAppSer.getAllTank().subscribe({
      next: (data) => {
        this.tankListMaster = data;
        this.loader.close();
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }
  getSolarMaster() {
    this.loader.start();
    this.farmerAppSer.getSolarMaster().subscribe({
      next: (data) => {
        this.loader.close();
        if (data) {
          this.solarMasterData = data;
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
      },
    });
  }

  openPreviousConsent(url) {
    window.open(url, '_blank');
  }

  downloadConsent() {
    window.open('/assets/consent.pdf', '_blank');
  }

  onUpload(event, formcontrol, uploadElement) {
    let file = event.files[0];
    let data = new FormData();
    data.append('file', file);
    let phNo = sessionStorage.getItem('farmerPh');
    this.loader.start();
    this._personalDetalSer
      .uploadFile(data, phNo, formcontrol)
      .subscribe((resp: any) => {
        this.loader.close();
        if (resp.statusCode == 200) {
          this.consentUploadPath = resp.data;
        }
      });
    uploadElement.clear();
  }

  onFarmersApplicationFormSubmit() {

    // console.log("miDetailsList", this.miDetailsList, this.miDetailsList.length == 0);
    // console.log("componentSelected", this.componentSelected);
    // console.log("coverageAreaSelected", this.coverageAreaSelected['Tank_ID'] );
    // console.log("coverageAreaSelected", this.coverageAreaSelected);
    // console.log("bankAccountSelected", this.bankAccountSelected);
    // console.log("solarApplicatonForm", this.solarApplicatonForm.value)


    // check validations
    if (this.componentSelected.component.includes('MI')) {
      if (this.miDetailsList.length == 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! MI list is empty',
          detail: 'Please Add MI details first',
        });
        return;
      }
    }

    if (this.componentSelected.component.includes('Pond')) {
      if (this.onFarmPondApplicatonForm.invalid) {
        this.isSubmittedPondApplicatonForm = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Pond Application Form Properly.',
        });
        return;
      }
    }

    if (this.componentSelected.component.includes('Solar')) {
      if (this.solarApplicatonForm.invalid) {
        this.isSubmittedSolarApplicatonFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill Solar Application Form Properly.',
        });
        return;
      }
    }




    //gettting primary solar vendor Id
    let filteredPrimarySolarVendor: any = this.primarySolarVendorList.filter(x => x.Primary_Vendor === this.selectedPrimarySolarVendor);

    //Populating Water 
    let waterCouseDetail = []
    if (this.selectedWatersourceType == 'Canal' || this.selectedWatersourceType == 'STP') {
      if (this.watercourseApplicatonForm.invalid) {
        this.isSubmittedWaterCourseFrom = true;
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message! Invalid',
          detail: 'Please Fill  Water Course Form Properly.',
        });
        return;
      }
      else {
        let body = {
          "outlet_Code": this.watercourseApplicatonForm.controls.outlet.value,
          "work_type": this.watercourseApplicatonForm.controls.workType.value
        }
        waterCouseDetail.push(body)
      }
    }

    //validation for bank details
    if (this.bankAccountSelected == undefined || this.bankAccountSelected == null) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message! Invalid',
        detail: 'Please Select the Bank Details.',
      });
      return;
    }

    //Validation for Group: Consent Form Path shouldnt be null
    if (this.applicationSelected === 'Group') {
      if (!this.consentUploadPath) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Please upload Consent Form',
        });
        return;
      }
    }

    //Validate if Total subsidy area is less than 12.5
    this.totalSubsidyArea = 0;
    this.miDetailsList.forEach((mi) => {
      this.totalSubsidyArea = this.totalSubsidyArea + Number(mi.totalArea);

    });
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if(subsidy.AppId != this.applicationId){
          this.totalSubsidyArea = this.totalSubsidyArea + Number(subsidy.Area);
        }
      }
    });
    //For Group Application, the total max subsidy allowed is calculated by No. of Farmer in Group Multiplied by '12.5' and Subtracting farmer previous subsidies from last 8 years
    if (this.applicationSelected === 'Group') {
      let maxSubsidyAreaForGroup = this.totalNumberOfFarmersInGroup * 12.5
      if (maxSubsidyAreaForGroup > 0) {
        if (this.totalSubsidyArea > maxSubsidyAreaForGroup) {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail:
              'Total Area Eligible for subsidy should be Less than ' + Number(maxSubsidyAreaForGroup) + 'Acre .For ' + this.totalNumberOfFarmersInGroup + 'Farmers (Group Application). You are applying for ' +
              Number(this.totalSubsidyArea) +
              ' Acre. \n\n Contact Department',
          });
          return;
        }
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Max SubSidy Area Cant be calculated for Group. Contact Department',
        });
        return;
      }
    } else {
      if (this.totalSubsidyArea > 12.5) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Total Area Eligible for subsidy should be Less than 12.5 Acre. You are applying for ' +
            Number(this.totalSubsidyArea) +
            ' Acre. \n\n Contact Department',
        });
        return;
      }
    }

    let totalArea = 0;
    this.miDetailsList.forEach((mi) => {
      totalArea = totalArea + Number(mi.totalArea);
    });
    //Validation for 'MI' if total area is less than 1 acre
    if (Number(totalArea) < 1 && Number(totalArea) != 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          'Data error! Total Area for MI form cannot be less than 1 Acre. ' +
          Number(totalArea),
      });
      return;
    }
    //Validation for 'Pond' if total area is less than 5 acre
    if (this.componentSelected.component.includes('Pond')) {
      if (Number(totalArea) < 5 && Number(totalArea) != 0) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Data error! Total Area for Pond form cannot be less than 5 Acre.Current Total Area is ' +
            Number(totalArea),
        });
        return;
      }
    }

    let farmerData: any = sessionStorage.getItem('farmerDetails');
    let appNo = JSON.parse(farmerData).Farmer_ID;
    let farmersApplicationToSubmit = {
      apP_ID: this.applicationId ? this.applicationId : '',
      farmer_ID: appNo,
      applicant_type: this.applicationSelected,
      scheme_Code: this.componentSelected.Scheme_ID,
      user_ID: sessionStorage.getItem('abyUserID')
        ? sessionStorage.getItem('abyUserID')
        : sessionStorage.getItem('userID'),
      is_Atal: sessionStorage.getItem('isAtalBhujal') === '1' || sessionStorage.getItem("isVendor") === '1' ? true : false,
      netWork_Id: this.ipAddress, 
      terminal_Id: this.ipAddress,
      consentPath: this.consentUploadPath ? this.consentUploadPath : '',
      group_Datas: this.selectedGroupFarmersLandList,
      water_Course_Datas: waterCouseDetail,
      onFarm_Pond_Datas: this.componentSelected.component.includes('Pond')
        ? [
          {
            land_ID: this.onFarmPondApplicatonForm.value['landId'],
            tank_id: this.onFarmPondApplicatonForm.value['tankId'],
          },
        ]
        : [],
      solar_Pump_Datas: this.componentSelected.component.includes('Solar')
        ? [
          {
            solar_ID: +this.solarApplicatonForm.value['solarId'],
            solar_Vendor_id: filteredPrimarySolarVendor[0].pid,
            solar_Vendor_Secondry_ID: this.selectedSecondarySolarVendorId,
            land_ID: this.solarApplicatonForm.controls.landId.value,
          },
        ]
        : [],
      new_MI_Datas: this.miDetailsList.map((r) => {
        return {
          // new_MI_System: this.miList.filter(
          //   (res) => res.Program_Name === r.mi
          // )[0]?.Program_Id,
          land_ID: r.landId,
          new_MI_System: r.mi,
          vendor_Code: r.vendorId?.Vendor_Code
            ? r.vendorId?.Vendor_Code
            : r.vendorCode,
        };
      }),
      bank_Datas: [
        {
          bank_Data: this.bankAccountSelected?.toString(),
        },
        // {
        //   "farmer_ID": appNo,
        //   "bank_ID": this.bankAccountSelected
        // }
      ],
    };

    this.postFarmersRegistrationData(farmersApplicationToSubmit);
  }
  getCurrentSubsidyArea() {
    let currentArea = 0
    this.miDetailsList.forEach((mi) => {
      currentArea = currentArea + Number(mi.totalArea);
    });
    return currentArea
  }
  getPreviousSubsidyArea() {
    let previousSubsidyArea = 0
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if (subsidy.AppId != this.applicationId) {
          previousSubsidyArea = previousSubsidyArea + Number(subsidy.Area);
        }
      }
    });
    return previousSubsidyArea
  }
  getTotalSubsidyArea() {
    let totalArea = 0
    this.miDetailsList.forEach((mi) => {
      totalArea = totalArea + Number(mi.totalArea);
    });
    this.farmerPreviousSubsidies.forEach((subsidy) => {
      if (subsidy.DiffYear < 8) {
        if (subsidy.AppId != this.applicationId) {
          totalArea = totalArea + Number(subsidy.Area);
        }
      }
    });
    return totalArea
  }
  postFarmersRegistrationData(farmersApplicationToSubmit) {
    let mobile = sessionStorage.getItem('farmerPh') ? sessionStorage.getItem('farmerPh') : '';

    this.loader.start();
    this.farmerAppSer
      .postFarmersRegistrationData(farmersApplicationToSubmit)
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data.startsWith('S:')) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.resetApplication();
            setTimeout(() => {
              this.router.navigate(['dashboard']);
            }, 1000);
          }
          else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: data,
            });
          }
          this.activityRecordService.activityRecord(mobile, 'Farmer Application Details Add/Edit', this.farmerId, new Date(), data, farmersApplicationToSubmit);

        },
        error: (err) => {
          this.loader.close();
          this.activityRecordService.activityRecord(mobile, 'Farmer Application Details Add/Edit', this.farmerId, new Date(), err, farmersApplicationToSubmit);

          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Farmer Application not saved.',
          });
        },
      });
  }

  resetApplication() {
    this.solarApplicatonForm.reset();
    this.onFarmPondApplicatonForm.reset();
    this.miDetailsList = [];
    this.isTargetReached = false;
  }

  getSolarVendorId() {
    let id = this.solarVendorList.filter(
      (r) =>
        this.solarApplicatonForm.value['secondaryVendor'].toLowerCase() ===
        r.Secondary_Vendor.toLowerCase() &&
        this.solarApplicatonForm.value['primaryVendor'].toLowerCase() ===
        r.Primary_Vendor.toLowerCase()
    )[0]?.Id;
    return id;
  }

  onBankAccountSelected(event) {
    this.bankAccountSelected = event.value;
  }

  onWaterSourceTypeSelected(event, ...args) {
    this.selectedWatersourceType = event.value;
    console.log("this.selectedWatersourceType", this.selectedWatersourceType);
    this.showComponent = true;
    this.showWaterCourseForm = true;
    if(!this.isVillhasCanal){
      if(this.selectedWatersourceType == 'Canal' || this.selectedWatersourceType == 'STP'){
        this.showComponent = false;
        this.showWaterCourseForm = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Info Message',
          detail: `${this.selectedWatersourceType} not found for the selected Village`,
        });
        return;
      }
    }
    // this.componentSelected.Scheme_ID = '';
    // this.componentSelected.component = '';
    console.log("waterSourceTypeList", this.waterSourceTypeList);
    let selectedWaterSourceData = [];
    if(args[0]== 'exists'){
      selectedWaterSourceData = args[1];
    }else{
      selectedWaterSourceData = this.waterSourceTypeList.filter(
        (d) => d.waterSource === this.selectedWatersourceType
      )[0].component;
    }
    console.log("selectedWaterSourceData", selectedWaterSourceData)
    this.componentList = selectedWaterSourceData
      .map((d) => {
        let keys = ['MI', 'Solar', 'Pond', 'Water_Course'];
        let filtered = keys.filter((r) => d[r] === true);
        return { component: filtered.join('+'), Scheme_ID: d.Scheme_ID };
      })
      .filter((r) => r.component && r.Scheme_ID);
    console.log('componentList', this.componentList)
  }

  onComponentSelected(event) {
    let selected = event.value;
    console.log("componentSelected", event);
    this.componentSelected = selected;
    console.log("componentSelected", this.componentSelected);

    let arr = this.componentSelected?.component.split("+");
    // console.log(arr);
    const MI = arr.includes("MI");
    const Pond = arr.includes("Pond");
    const Solar = arr.includes("Solar");

    // console.log(MI, Pond, Solar);

    let reqBody = {
      AppId: this.applicationId ? this.applicationId : '',
      VillageCode: this.selectedVillageCode,
      MI: MI,
      Pond: Pond,
      Solar: Solar
    }
    this.targetStatusBody={...reqBody}
    // this.getTargetStatus(reqBody);
  }

  getTargetStatus(reqBody) {
    this.loader.start();
    this._personalDetalSer.getTargetStatus(reqBody).subscribe({
      next: (data) => {
        console.log(data,"data@@@@@@")
        if(data['Status'] == "Application from your district is stopped as target area for current Quarter/Year is reached"){
          this.isTargetReached = true;
          this.messageService.add({
            severity: 'info',
            summary: 'Info Message',
            detail: data['Status'],
          });
        }else{
          this.isTargetReached = false;
        }
        if(data.Status!='0'){
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `err: ${data.Status}`,
          });

        }
        this.loader.close();
      }, 
      error: (err) => {
        this.isTargetReached = false;
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: err,
        });
      }
    })
  }

  onApplicationTypeSelected(event) {
    let selected = event.value;
    // this.getVillageData();
    this.applicationSelected = selected;
    this.waterSourceTypeList = [];
    this.componentList = [];
    let selectedAppData = this.schemeMasterList.filter(
      (d) => d.type === this.applicationSelected
    )[0].data;
    this.loader.start();
    of(...selectedAppData)
      .pipe(
        groupBy((p: any) => p.Source_Name),
        mergeMap((group$) =>
          group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
        ),
        map((arr) => ({ waterSource: arr[0], component: arr.slice(1) })),
        toArray()
      )
      .subscribe((p) => {
        this.loader.close();
        this.waterSourceTypeList = p;
        if (this.applicationSelected == 'Individual') {
          // this.listAllOutletData();
        } else {
          this.canalOutletList = [];
        }
      }, error => {
        this.loader.close();
      });
  }

  onCanalOutletSelected(event) {
    let selected = event.value;
    this.outletTypeList = [];
    let selectedAppData = this.canalOutletList?.filter(
      (d) => d.canal === selected
    )[0].data;
    this.outletTypeList = selectedAppData;
    console.log("this.outletTypeList", this.outletTypeList)
    // if (!this.applicationId) {
    //   if (
    //     this.selectedWatersourceType == 'Canal' ||
    //     this.selectedWatersourceType == 'STP'
    //   ) {
    //     console.log("this.landIDList", this.selectedLandIdList)
    //     console.log("this.selectedLandIdList", this.selectedLandIdList)
    //     this.landIDList = this.selectedLandIdList?.filter(
    //       (x) => x.Village_Code == this.outletTypeList[0].villageCode
    //     );
    //     console.log("this.landIDList", this.selectedLandIdList)
    //   } else {
    //     this.landIDList = this.selectedLandIdList;
    //   }
    // }
  }

  editProduct(ele) {
    this.selectedMI=ele.mi
    this.miSelectedVendor=ele.vendorId
    this.miApplicatonForm.reset();
    this.miApplicatonForm.patchValue({
      landId: ele.landId,
      // landId: this.landIDList.filter(r => r.Land_ID === ele.landId)[0].displayName,
      mi: ele.mi,
      vendor: ele.vendorId,
    });
    this.addBankDialog = true;
  }
  editFarmersInGroup(ele) {
    // this.miApplicatonForm.reset();
    // this.miApplicatonForm.patchValue({
    //   landId: ele.Land_ID,
    //   // landId: this.landIDList.filter(r => r.Land_ID === ele.landId)[0].displayName,
    //   mi: ele.mi,
    //   vendor: ele.vendor
    // });
    this.addFarmerGroupDialog = true;
  }

  deleteProduct(ele) {
    this.confirmationService.confirm({
      message: 'Are you sure you want to delete ?',
      header: 'Confirm',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.miDetailsList = this.miDetailsList.filter(
          (val) => val.landId !== ele.landId
        );
        if(this.miDetailsList.length==0){
          this.isDisabled=false;
        }
      },
    });
  }
  deleteFarmersInGroup(ele) { }

  hideDialog() {
    this.miApplicatonForm.reset();
    this.addBankDialog = false;
  }
  hideFarmersAddToGroupDialog() {
    this.addFarmerGroupDialog = false;
  }

  saveProduct() {
    // mi: [''],
    // vendor: [''],
    // landId: ['']
   
    let filteredLand = this.landIDList.filter((x) => {
      return x.LandID == this.miApplicatonForm.value['landId'];
    });
    this.targetStatusBody['LandId']=this.miApplicatonForm.value['landId']
    this.targetStatusBody['ProgramId'] =this.selectedMI
    this.targetStatusBody['ApplyArea'] =filteredLand[0]?.TotalArea
    
    this.getTargetStatus( this.targetStatusBody);
    let vendorName = this.miVendorList.filter(
      (x) =>
        x.Vendor_Code == this.miApplicatonForm.value['vendor']['Vendor_Code']
    )[0]?.Name;
    console.log('Filtered Land', filteredLand);
    let miFarmValue = {
      mi: this.miApplicatonForm.value['mi'],
      vendor: vendorName,
      landId: this.miApplicatonForm.value['landId'],
      vendorId: this.miApplicatonForm.value['vendor'],
      landData: filteredLand[0]?.displayName,
      totalArea: filteredLand[0]?.TotalArea,
    };

    this.miDetailsList = this.miDetailsList.filter(
      (val) => val.landId !== miFarmValue.landId
    );

    this.miDetailsList.push(miFarmValue);
    this.miApplicatonForm.reset();
    this.addBankDialog = false;
    console.log(this.miApplicatonForm.value)
  }

  saveFarmerToGroup() {
    this.selectedFarmersLandList = [];
    this.selectedGroupFarmersLandList = [];
    console.log(this.selectedFarmerLandDetails);
    if (this.applicationSelected === 'Group') {
      let farmerIds = []
      this.selectedFarmerLandDetails.forEach(farmer => {
        farmerIds.push(farmer.Farmer_ID.toString())
      })
      this.totalNumberOfFarmersInGroup = farmerIds.length;
      if (farmerIds.length) {
        this.loader.start();
        this.ofService
          .GetFarmerPastSubsidyByMultipleFarmerIds(farmerIds)
          .pipe(first())
          .subscribe({
            next: (data) => {
              this.farmerPreviousSubsidies = data;
              this.loader.close();
            },
            error: () => {
              this.loader.close();
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Data error! Farmer Previous Subsidies not loaded.',
              });
            },
          });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! Group-Farmers Previous Subsidies not Fetched.',
        });
        return;
      }
    }
    this.selectedFarmerLandDetails.forEach((r) => {
      r.landDetails.forEach((element) => {
        // this.selectedFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID,
        //   "farmersName": r.Name,
        //   "village": r.vendorId ? r.venorId : r.Village_Code
        // })
        // this.selectedGroupFarmersLandList.push({
        //   "farmer_Id": element.Farmer_ID ? element.Farmer_ID : element.farmerId,
        //   "landID": element.Land_ID ? element.Land_ID : element.LandID
        // })

        let filteredLands = this.selectedFarmersLandIdList.filter((x) => {
          return (
            x.Land_ID == (element.LandID ? element.LandID : element.Land_ID)
          );
        });

        if (filteredLands.length) {
          this.selectedFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
            farmersName: r.Name,
            // village: r.vendorId ? r.venorId : r.Village_Code,
            village: r.vendorId ? r.venorId : this.selectedVillage?.VillageName,
          });
          this.selectedGroupFarmersLandList.push({
            farmer_Id: element.Farmer_ID ? element.Farmer_ID : element.farmerId,
            landID: element.Land_ID ? element.Land_ID : element.LandID,
          });
        }
      });
    });
    this.addFarmerGroupDialog = false;
  }

  getFarmerLandByFarmerIds() {
    let farmerIds = [];
    //Here for Individual application Type
    if (this.applicationSelected === 'Individual') {
      let farmerData: any = sessionStorage.getItem('farmerDetails');
      let farmerId = JSON.parse(farmerData).Farmer_ID;
      farmerIds.push(farmerId.toString());
    } else {
      let farmerData: any = sessionStorage.getItem('farmerDetails');
      let farmerId = JSON.parse(farmerData).Farmer_ID;
      farmerIds.push(farmerId.toString());
      this.selectedFarmersLandList?.forEach((x) => {
        farmerIds.push(x.farmer_Id?.toString());
      });
    }

    let villageCodes = [];
    villageCodes.push(this.selectedVillageCode.toString());
    let body = {
      farmerId: farmerIds,
      villageCode: villageCodes,
    };
    this.loader.start();
    this.farmerAppSer.GetFarmerLandByFarmerIds(body).subscribe({
      next: (data) => {
        this.loader.close();
        if (data.length) {
          this.landIDList = this.transformLandIDData(data);
          return;
        }
      },
      error: (err) => {
        this.loader.close();
        console.log(err);
        //this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Cannot Get Farmer lands for Selected Village.' });
      },
    });
  }

  openNew() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.miApplicatonForm.reset();
    this.getFarmerLandByFarmerIds();
    // this.getLandIds();
    this.addBankDialog = true;
  }
  addFarmersInGroup() {
    // this.bankAccount = {};
    // this.submitted = false;
    this.addFarmerGroupDialog = true;
  }

  validateAndGetSolarVendors() {
    if (
      this.solarApplicatonForm.controls.controlType.value &&
      this.solarApplicatonForm.controls.pump.value &&
      this.solarApplicatonForm.controls.pumpType.value &&
      this.solarApplicatonForm.controls.pumpCapacity.value
    )
      this.getPrimarySolarVendors();
  }

  onCapacityOfPumpSelected(event) {
    if (!this.solarApplicatonForm.controls.controlType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - controlType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pump.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pump Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpType.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpType Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.pumpCapacity.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - pumpCapacity Cant be Empty',
      });
      return;
    } else if (!this.solarApplicatonForm.controls.landId.value) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail: 'Data error! SOLAR FORM - landId Cant be Empty',
      });
    }

    this.validateAndGetSolarVendors();
  }

  getFarmerShare() {
    return this.solarMasterData.filter(
      (d: any) =>
        d.Pump_Controler_Type ===
        this.solarApplicatonForm.value['controlType'] &&
        d.Pump_Capacity === this.solarApplicatonForm.value['pumpCapacity'] &&
        d.Pump_Category === this.solarApplicatonForm.value['pumpType'] &&
        d.Pump_Type === this.solarApplicatonForm.value['pump']
    )[0];
  }

  onPondLandIdSelected(event) {
    this.selectedPondLand = event.value;
  }

  onCoverageAreaSelected(event) {
    this.coverageAreaSelected = event.value;
    this.onFarmPondApplicatonForm.patchValue({
      topSize: this.coverageAreaSelected.Top_Size,
      bottomSize: this.coverageAreaSelected.Bottom_Size,
      depth: this.coverageAreaSelected.Depth,
      waterCapacity: this.coverageAreaSelected.Water_Capacity,
      tenativeCost: this.coverageAreaSelected.Total_Cost,
      tankId: this.coverageAreaSelected.Tank_ID,
    });
  }

  onSolarLandIdSelected(event) { }

  onVendorSelect(event) { }

  selectRow(checkValue, data) {
    if (checkValue) {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index == -1) {
        this.selectedFarmersLandIdList.push(data);
      }
    } else {
      let index = this.selectedFarmersLandIdList.indexOf(data);
      if (index !== -1) {
        this.selectedFarmersLandIdList.splice(index, 1);
      }
    }
  }

  selectHeaderRow(checkValue, data) {
    if (checkValue) {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index == -1) {
          this.selectedFarmersLandIdList.push(element);
        }
      });
    } else {
      data.forEach((element) => {
        let index = this.selectedFarmersLandIdList.indexOf(element);
        if (index !== -1) {
          this.selectedFarmersLandIdList.splice(index, 1);
        }
      });
    }
  }

  onSelectMI() {
    console.log(this.miList,"miListmiList")
    console.log('programId', this.selectedMI);
    this.selectedProgramId = this.selectedMI
    this.getAllMIvenders(this.selectedMI);
    if(this.miDetailsList.length>0){
      this.miDetailsList.forEach(e=>{
        if(e.mi==this.selectedMI){
          this.isDisabled=true;
          this.miSelectedVendor=e.vendorId
          console.log(this.miDetailsList,"this.miDetailsList")
          return;
        }
        else{
          this.isDisabled=false;
        } 
      })

    }

  }

  getAllMIvenders(programId) {
    this.loader.start();
    this.farmerAppSer
      .getAllMIvenders(programId)
      .pipe(first())
      .subscribe({
        next: (res) => {
          console.log("All MI Vendor Data", res)
          this.miVendorList = res;
          this.loader.close();
        },
        error: () => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! Category not loaded.',
          });
        },
      });
  }

  getAllOutletDataN(villageCode: any) {
    this.loader.start();
    this.farmerAppSer.GetAllOutletDetails(villageCode)
    .subscribe({
      next: (res) => {
        of(...res)
        .pipe(
          groupBy((p: any) => p.canal),
          mergeMap((group$) =>
            group$.pipe(reduce((acc, cur) => [...acc, cur], [`${group$.key}`]))
          ),
          map((arr) => ({ canal: arr[0], data: arr.slice(1) })),
          toArray()
        )
        .subscribe((p) => {
          // this.waterSourceTypeList[0].disabled = false;
          this.isVillhasCanal = true;
          this.showWaterCourseForm = true;
          this.showComponent = true;
          this.canalOutletList = p;
          this.loader.close();
          if(this.applicationId){
            this.onCanalOutletSelected({ value: this.watercourseApplicatonForm.controls.canal.value });
          }
        });
      },
      error: (err) => {
        console.log('err', err)
        this.isVillhasCanal = false;
        // this.waterSourceTypeList[0].disabled = true;
        this.loader.close();  
      },
    });
  }

  getIP() {
    this.ipService.getIPAddress().subscribe((res: any) => {
      this.ipAddress = res.ip;
    });
  }
}
